import React from 'react';

import { Icon } from '@iconify/react';

type CancellationConfig = {
  getPrimaryImage: (isDesktop: boolean) => JSX.Element;
};

// ChatWithAI uses its own cancellation variant (polyllm); this per-project
// config is retained only for the unrouted legacy cancellation views.
export const CANCELLATION_PROJECT_CONFIG: CancellationConfig = {
  getPrimaryImage: (): JSX.Element => (
    <Icon
      icon="material-symbols:sentiment-sad-outline"
      width={120}
      height={120}
    />
  ),
};
